import React, { useState } from 'react';
import { Notes } from '../../components/Notes';
import { ViewAllNotes } from '../../components/ViewAllNotes';

const NotesSection = ({
    openNotesSection,
    noteCount,
    setNoteCount,
    noteTypes,
    viewNotes,
    showNotes,
    selectedDocId,
    handleReset,
}) => {
    return openNotesSection ? (
        <div className='wrap_details wrap_note p-4'>
            <div
                className={
                    noteCount === 0
                        ? 'd-flex details_part align-items-stretch justify-content-between'
                        : 'd-flex mb-5 details_part align-items-stretch justify-content-between'
                }
            >
                <div className='details_fun'>
                    <span>
                        <i
                            title='Notes'
                            className='fa-solid fa-sticky-note'
                        ></i>
                        Notes
                    </span>
                </div>
            </div>
            {noteCount === 0 && (
                <div className='no_result norecordfound mt-0 mb-3'>
                    <span>No Notes Found</span>
                </div>
            )}

            {viewNotes && <ViewAllNotes selectedDocId={selectedDocId} />}

            {showNotes && noteTypes.length > 0 && (
                <>
                    <hr />
                    <Notes
                        openNote={openNotesSection}
                        docId={selectedDocId}
                        type='normal'
                        updateState={() => setNoteCount(noteCount + 1)}
                        handleReset={handleReset}
                        viewAllOpen
                    />
                </>
            )}
        </div>
    ) : null;
};

export default NotesSection;
